import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "../../core/utils";

// Store
import { Actions } from "../../store/actions";

// Components
import { Button, Popover } from "antd";

export const UserModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const store = useSelector((state) => state?.Store);

  const logout = () => {
    dispatch(Actions.LogoutUser());
    history.push("/login/");
  };

  // const close = () => {
  //   setShowUserModal(false);
  // };

  const profileContent = (
    <div className="user-popover">
      <div className="name">
        <div className="mr-5">
          <i className="far fa-user"></i>
        </div>
        <div className="text">
          <span>{`${store.user?.first_name} ${store.user?.last_name}`}</span>
        </div>
      </div>
      <div className="username mt-15">
        <div className="mr-5">
          <i className="far fa-lock"></i>
        </div>
        <div className="text">
          <span>{store.user?.username}</span>
        </div>
      </div>
      <div className="flex-row mt-15">
        <Button className="button-red w-100" onClick={() => logout()}>
          Logout
        </Button>
      </div>
    </div>
  );

  return (
    <Popover placement="bottomRight" content={profileContent} trigger="click">
      <button className="user-button">
        <i className="far fa-user"></i>
      </button>
    </Popover>
  );
};
